import {
    USER_AUTHENTICATED,
    USER_NOT_AUTHENTICATED
} from '../_actions/types'
import {User} from '../_services/User';

export type UserAction = {
    type: string;
};

export type UserState = {
    isAuthenticated: boolean;
};

const initialState: UserState = {
    isAuthenticated: !!(User.getInstance().getAuthToken()),
};

export const reducer = (state: UserState = initialState, action: UserAction): UserState => {
    switch (action.type) {
        case USER_AUTHENTICATED:
            return {...state, isAuthenticated: true};
        case USER_NOT_AUTHENTICATED:
            return {...state, isAuthenticated: false};
        default:
            return state;
    }
};